import React from 'react';

import './Dashboard.scss';
import plus from 'assets/images/icons/plus.svg';
import { Button } from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { NextEvents } from './Components/NextEvents/NextEvents';
import { LastPersons } from './Components/LastPersons/LastPersons';
import useDashboardVM from './useDashboardVM';
import { Appointments } from './Components/Appointments/Appointments';

export const Dashboard: React.FunctionComponent = () => {
    const navigate = useNavigate();
    const {
        isLoading,
        dashboardData,
    } = useDashboardVM();

    return (
        <main id="dashboard">
            <div className="top">
                <Button
                    label="Soutenir une personne"
                    variant="yellow"
                    icon={<img src={plus} alt="" />}
                    iconBefore
                    callback={() => navigate('/app/admin/persons/new')}
                />
            </div>
            <div className="dashboard-content">
                <div className="left">
                    <LastPersons isLoading={isLoading} data={dashboardData?.persons ?? []} />
                </div>
                <div className="right">
                    <NextEvents isLoading={isLoading} data={dashboardData?.events ?? []} />
                    <Appointments
                        isLoading={isLoading}
                        data={dashboardData?.appointments ?? []}
                    />
                </div>
            </div>
        </main>
    );
};
